var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57141 9.0001C2.57141 5.4497 5.44958 2.57153 8.99998 2.57153C12.5504 2.57153 15.4286 5.4497 15.4286 9.00011C15.4286 12.5505 12.5504 15.4287 8.99998 15.4287C5.44958 15.4287 2.57141 12.5505 2.57141 9.0001Z",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71423 7.45888C7.81793 7.11532 8.02261 6.82562 8.29201 6.64108C8.56142 6.45655 8.87817 6.3891 9.18616 6.45067C9.49414 6.51224 9.7735 6.69886 9.97474 6.97748C10.176 7.2561 10.2861 7.60874 10.2857 7.97293C10.2857 9.00105 8.96246 9.5151 8.96246 9.5151M8.99774 11.5713H9.00215",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.042c157225d78161ecb8713801d0271b.svg";
export { ForwardRef as ReactComponent };